import React from 'react';

import { generalConstants } from '../constants';
import { TextInput, TextArea, ImageInput } from '../components';

class UploadImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: '',
      imagePreviewUrl: ''
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.refs.fileUploader.click();
  }

  render() {
    const imgStyle = {
      maxWidth: '100%',
      maxHeight: '100%'
    };
    const {
      image,
      image_onChange,
      title_value,
      title_onChange,
      alt_value,
      alt_onChange,
      desc_value,
      desc_onChange
    } = this.props;

    //if (!this.props.show) {
    //return null;
    //}
    console.log('image', image);
    return (
      //harus terbungkus dalan 1 div
      <div>
        <button
          type="button"
          className="btn btn-success"
          data-toggle="modal"
          data-target="#myModal"
        >
          <i className="fa fa-plus" />
        </button>

        <div className="modal fade" id="myModal">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Modal Heading</h4>
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>

              <div className="modal-body">
                <div className="form-group">
                  <div className="form-group">
                    <label className="form-control-label">Image</label>
                    <input
                      type="file"
                      ref="fileUploader"
                      name="file"
                      style={{ display: 'none' }}
                      onChange={image_onChange}
                    />
                    <button
                      className={'uploader-img' + (image.meta.data ? ' uploader-img-filled' : '')}
                      onClick={this.handleClick}
                      style={{ width: '100%' }}
                    >
                      {image.meta.data ? (
                        <img
                          src={generalConstants.BASE_URL + image.meta.data.url}
                          style={imgStyle}
                          className="img-responsive"
                          alt="Image Uploaded"
                        />
                      ) : (
                        <div className="icon">
                          <i className="fa fa-arrow-circle-o-up" />
                        </div>
                      )}
                    </button>
                  </div>

                  <TextInput
                    input_label="Title"
                    input_placeholder="Enter Title"
                    input_name="title"
                    input_type="text"
                    input_onChange={title_onChange}
                    input_value={title_value}
                  />

                  <TextArea
                    input_label="Description"
                    input_placeholder="Enter description text"
                    input_rows="4"
                    input_name="description"
                    input_type="text"
                    input_onChange={desc_onChange}
                    input_value={desc_value}
                  />

                  <TextInput
                    input_label="Alt"
                    input_placeholder="Enter Alt"
                    input_name="alt"
                    input_type="text"
                    input_onChange={alt_onChange}
                    input_value={alt_value}
                  />
                  <button
                    type="submit"
                    className="btn btn-success"
                    data-dismiss="modal"
                    onClick={this.props.onSave}
                  >
                    Save
                  </button>
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export { UploadImage };



// WEBPACK FOOTER //
// ./src/components/UploadImage.js